import React from "react";
import { Link } from 'gatsby';
import * as Icon from 'react-feather';

// import Logo from "../../assets/getwidget/logo.png"

const NavbarStyleThree = () => {
    const [menu, setMenu] = React.useState(true)

    const toggleNavbar = () => {
        setMenu(!menu)
    }

    React.useEffect(() => {
        let elementId = document.getElementById("header");
        document.addEventListener("scroll", () => {
            if (window.scrollY > 170) {
                elementId.classList.add("is-sticky");
            } else {
                elementId.classList.remove("is-sticky");
            }
        });
        window.scrollTo(0, 0);
    })

    const classOne = menu ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = menu ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';

    return (
        <header id="header" className="headroom new-header navbar-style-three">
            <div className="startp-nav">
                <div className="container-fluid">
                    <nav className="navbar navbar-expand-md navbar-light">
                        <Link  href="https://www.ionicfirebaseapp.com/" target="_blank"  onClick={toggleNavbar} className="navbar-brand">
                            <img src="https://ik.imagekit.io/ionicfirebaseapp/ionicfirebaseapp/ionicfirebase-home/tr:dpr-auto,tr:w-1200/white-logo_4itKrR21W.png" alt="ionic-firebase-logo"  className="logo-img"></img>
                            {/* <img src="https://ik.imagekit.io/ionicfirebaseapp/ionicfirebaseapp/ionicfirebase-home/logo-christmas_G5QzKJvt7.svg" alt="ionic-firebase-logo"  className="logo-img"/> */}
                        </Link>

                        <button
                            onClick={toggleNavbar}
                            className={classTwo}
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="icon-bar top-bar"></span>
                            <span className="icon-bar middle-bar"></span>
                            <span className="icon-bar bottom-bar"></span>
                        </button>

                        <div className={classOne} id="navbarSupportedContent">
                            <ul className="navbar-nav ms-auto">
                                {/* <li className="nav-item">
                                    <Link to="" href="https://www.ionicfirebaseapp.com/" target="_blank"  activeClassName="active" className="nav-link">
                                        Home
                                    </Link>
                                </li> */}

<li className="nav-item">
                                    <Link to="https://www.ionicfirebaseapp.com"  target="_blank"  activeClassName="active"  className="nav-link">
                                        Home
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/"  activeClassName="active"  className="nav-link">
                                        Blogs
                                    </Link>
                                </li>
                                <li className="nav-item">
                                   <div className="service-section">
                                   <Link to="https://www.ionicfirebaseapp.com/services" target="_blank"  activeClassName="active" className="nav-link title">
                                        Services <img src="https://ik.imagekit.io/ionicfirebaseapp/ionicfirebaseapp/ionicfirebase-home/tr:dpr-auto,tr:w-1200/green-arrow_IzQbU8iYf.png" className="green-arrow" alt="green-arrow"></img>
                                    </Link>

                                    <div className="service-dropdown">

                                        <Link to="https://www.ionicfirebaseapp.com/services/mobile-app-development-company" target="_blank">Mobile App Development</Link>
                                        <Link to="https://www.ionicfirebaseapp.com/flutter-app-development-company" target="_blank">Flutter App Development</Link>
                                        <Link to="https://www.ionicfirebaseapp.com/services/grocery-shopping-app-development" target="_blank">Grocery App Development</Link>
                                        <Link to="https://www.ionicfirebaseapp.com/on-demand-app-development" target="_blank">On Demand App Development</Link>
                                        <Link to="https://www.ionicfirebaseapp.com/hire-app-developer" target="_blank">Hire App Development</Link>
                                    </div>
                                   </div>

                                    
                                </li>
                                <li className="nav-item">
                                 <div className="products-section">
                                 <Link to="https://www.ionicfirebaseapp.com/products" target="_blank"   activeClassName="active"  className="nav-link">
                                        Readymade App  <img src="https://ik.imagekit.io/ionicfirebaseapp/ionicfirebaseapp/ionicfirebase-home/tr:dpr-auto,tr:w-1200/green-arrow_IzQbU8iYf.png" className="green-arrow" alt="green-arrow"></img>
                                    </Link>
                                    <div className="products-dropdown">

<Link to="https://www.ionicfirebaseapp.com/category/mobile-app" target="_blank">Mobile App </Link>
<Link to="https://www.ionicfirebaseapp.com/category/flutter-app" target="_blank">Flutter App </Link>
<Link to="https://www.ionicfirebaseapp.com/category/grocery-app" target="_blank">Grocery App </Link>
<Link to="https://www.ionicfirebaseapp.com/category/food-ordering-app" target="_blank">Food Ordering App </Link>
<Link to="https://www.ionicfirebaseapp.com/category/multi-restaurant" target="_blank">MultiRestaurant App </Link>
</div>
                                 </div>
                                </li>
                                <li className="nav-item">
                                 <div className="clone-section">
                                 <Link to="https://www.ionicfirebaseapp.com/clone-app-development" target="_blank"   activeClassName="active"  className="nav-link">
                                        Clone App Development  <img src="https://ik.imagekit.io/ionicfirebaseapp/ionicfirebaseapp/ionicfirebase-home/tr:dpr-auto,tr:w-1200/green-arrow_IzQbU8iYf.png" className="green-arrow" alt="green-arrow"></img>
                                    </Link>
                                    <div className="clone-dropdown">

<Link to="https://www.ionicfirebaseapp.com/zomato-clone-app" target="_blank">Zomato Clone App </Link>
<Link to="https://www.ionicfirebaseapp.com/ubereats-clone-app" target="_blank">Uber Clone App </Link>

</div>
                                 </div>
                                </li>
                                <li className="nav-item">
                                    <Link to="https://www.ionicfirebaseapp.com/contact" activeClassName="active" className="nav-link">
                                    <button className="get-quote btn" type="button"><p className="m-0">GET A FREE QUOTE</p></button>
                                    </Link>
                                </li>
                                {/* <li className="nav-item">
                                    <Link to="https://www.getwidget.dev/" target="_blank" activeClassName="active" className="nav-link">
                                        Opensource Library
                                    </Link>
                                </li> */}
                                {/* <li className="nav-item">
                                    <Link to="https://www.ionicfirebaseapp.com/products" target="_blank" activeClassName="active" className="nav-link">
                                    Readymade Mobile App
                                    </Link>
                                </li> */}
                                {/* <li >
                                    <Link to="https://wa.me/+918050032994" target="_blank">
                                  
                                        <img src="https://ik.imagekit.io/ionicfirebaseapp/getwidget/watsap_6ErwXJlDEMPN.png" style={{ height: "30px", margin: "14px" }} />
                                    </Link>
                                </li> */}
                                {/* <li className="nav-item">
                                    <Link to="https://forum.getwidget.dev/" target="_blank" activeClassName="active" className="nav-link">
                                        Forum
                                    </Link>
                                </li> */}
                                {/* <li className="nav-item">
                                    <Link to="#" onClick={e => e.preventDefault()} className="nav-link">
                                        <Icon.Search />
                                    </Link>

                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <Link to="" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                <input placeholder="Search here"/>
                                            </Link>
                                            <a onClick={toggleNavbar} className="nav-link">
                                                <input placeholder="Type and hit enter" />
                                            </a>
                                        </li>
                                    </ul>
                                </li> */}

                                {/* <li className="nav-item">
                                    <Link to="#" onClick={e => e.preventDefault()} className="nav-link">
                                        About <Icon.ChevronDown />
                                    </Link>

                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <Link to="/about-1" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                About Style 1
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/about-2" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                About Style 2
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/about-3" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                About Style 3
                                            </Link>
                                        </li>
                                    </ul>
                                </li>

                                <li className="nav-item">
                                    <Link to="#" onClick={e => e.preventDefault()} className="nav-link">
                                        Pages <Icon.ChevronDown />
                                    </Link>

                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <Link to="#" activeClassName="active" onClick={e => e.preventDefault()} className="nav-link">
                                                Features <Icon.ChevronDown />
                                            </Link>

                                            <ul className="dropdown-menu">
                                                <li className="nav-item">
                                                    <Link to="/features" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Features
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/feature-details" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Features Details
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="#" activeClassName="active" onClick={e => e.preventDefault()} className="nav-link">
                                                Services <Icon.ChevronDown />
                                            </Link>

                                            <ul className="dropdown-menu">
                                                <li className="nav-item">
                                                    <Link to="/services-1" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Services Style 1
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/services-2" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Services Style 2
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/services-3" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Services Style 3
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/services-4" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Services Style 4
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/services-5" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Services Style 5
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/service-details" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Services Details
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/feedback" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Feedback
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="#" activeClassName="active" onClick={e => e.preventDefault()} className="nav-link">
                                                Projects <Icon.ChevronDown />
                                            </Link>

                                            <ul className="dropdown-menu">
                                                <li className="nav-item">
                                                    <Link to="/projects-1" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Project Style 1
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/projects-2" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Project Style 2
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/project-details" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Project Details
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/team" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Team
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/pricing" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Pricing
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="#" activeClassName="active" onClick={e => e.preventDefault()} className="nav-link">
                                                User <Icon.ChevronDown />
                                            </Link>

                                            <ul className="dropdown-menu">
                                                <li className="nav-item">
                                                    <Link to="/login" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Login
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/sign-up" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Sign Up
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link to="/forgot-password" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                        Forgot Password
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/faq" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                FAQ's
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/coming-soon" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Coming Soon
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/404" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                404 Error Page
                                            </Link>
                                        </li>
                                    </ul>
                                </li>

                                <li className="nav-item">
                                    <Link to="#" activeClassName="active" onClick={e => e.preventDefault()} className="nav-link">
                                        Shop <Icon.ChevronDown />
                                    </Link>

                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <Link to="/shop" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Shop
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/product-details" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Products Details
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/cart" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Cart
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/checkout" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Checkout
                                            </Link>
                                        </li>
                                    </ul>
                                </li>

                                <li className="nav-item">
                                    <Link to="#" onClick={e => e.preventDefault()} className="nav-link">
                                        Blog <Icon.ChevronDown />
                                    </Link>

                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <Link to="/blog-1" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Blog Grid
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/blog-2" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Blog Right Sidebar
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/blog-3" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Blog Grid 2
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/blog-4" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Blog Right Sidebar 2
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/blog-5" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Blog Grid 3
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/blog-6" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Blog Right Sidebar 3
                                            </Link>
                                        </li>

                                        <li className="nav-item">
                                            <Link to="/blog-details" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                                Blog Details
                                            </Link>
                                        </li>
                                    </ul>
                                </li> */}

                                {/* <li className="nav-item">
                                    <Link to="/contact" activeClassName="active" className="nav-link">
                                        Contact
                                    </Link>
                                </li> */}

                            </ul>
                        </div>

                        {/* <div className="others-option"> */}
                        {/* <Link to="/cart" className="cart-wrapper-btn">
                                <Icon.ShoppingCart />
                                <span>0</span>
                            </Link> */}

                        {/* <Link to="/contact" className="btn btn-light">
							    Support
                            </Link> */}

                        {/* <Link to="/login" className="btn btn-primary">
                                Login
                            </Link> */}
                        {/* </div> */}
                        {/* <div className={classOne} id="navbarSupportedContent">
                        <ul className="navbar-nav">
                        <li className="nav-item">
                                    <Link to="#" onClick={e => e.preventDefault()} className="nav-link">
                                        <Icon.Search />
                                    </Link>

                                    <ul className="dropdown-menu">
                                        <li className="nav-item">
                                            <Link to="" activeClassName="active" onClick={toggleNavbar} className="nav-link">
                                            <input placeholder="Search here"/>
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                        </ul>
                        </div> */}

                    </nav>
                </div>
            </div>
        </header>
    );
}

export default NavbarStyleThree;
